import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { to12Hr } from "../../../../helpers/moment";
import "./styles.css";

const WeekDaySchedule = ({
  day,
  getWeekDaysSites,
  getWeekDaysShifts,
  sites,
  siteShifts,
  preferredShifts,
  activeDate,
  activeSite,
  config,
  setPreferredShifts,
}) => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const { API_URL } = config;
  const [selectedShifts, setSelectedShifts] = React.useState([]);

  React.useEffect(() => {
    getPreferredShifts(preferredShifts);
  }, [preferredShifts]);

  const isSelected = (shift_id) =>
    selectedShifts.some((id) => id === shift_id) &&
    preferredShifts.some(
      (shift) =>
        shift.date === day.format("YYYY-MM-DD") && shift.shift_id === shift_id
    );

  const isDisabled = () => {
    let status = true;
    const formattedDay = day.format("YYYY-MM-DD");
    const formattedActiveDay = activeDate.format("YYYY-MM-DD");
    if (moment(formattedActiveDay).isSameOrBefore(moment(formattedDay))) {
      status = false;
    }

    return status;
  };

  const togglePreferenceBtn = async (shift_id) => {
    let data = {
      date: day.format("YYYY-MM-DD"),
      shift_id: shift_id,
      is_available: 1,
      remarks: null,
    };

    if (isSelected(shift_id)) {
      removeSelected(shift_id);

      data.pick = false;
    } else {
      addSelected(shift_id);

      setPreferredShifts((prev) => {
        let newState = prev;

        newState.push({
          date: day.format("YYYY-MM-DD"),
          shift_id: shift_id,
          is_available: 1,
          remarks: null,
        });

        return newState;
      });

      data.pick = true;
    }

    await submitShiftPreference(data);
  };

  const addSelected = (shift_id) => {
    let clone = JSON.parse(JSON.stringify(selectedShifts));
    clone.push(shift_id);
    setSelectedShifts(clone);
  };

  const removeSelected = (shift_id) => {
    let clone = JSON.parse(JSON.stringify(selectedShifts));
    let filtered = clone.filter((id) => id !== shift_id);
    setSelectedShifts(filtered);
  };

  const getPreferredShifts = (prefShifts) => {
    setSelectedShifts(prefShifts.map((item) => item.shift_id));
  };

  const submitShiftPreference = async (data) => {
    let url = `${API_URL}/associate/sites/${activeSite}/set_shift_preference`;

    try {
      let response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        withCredentials: true,
        mode: "cors",
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        Swal.fire({
          title: "Error",
          text: "Unable to update the shift preference. Please try again.",
          icon: "error",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error,
        icon: "error",
      });
    }
  };

  return (
    <div className="dashboard__weekschedule-item-container">
      <div className="dashboard__weekschedule-item-day">
        <p className="p1">{day.format("DD/M")}</p>
        <p className="p2">{day.format("dddd")}</p>
      </div>
      <div className="dashboard__weekschedule-item-course">
        {siteShifts
          .filter((shift) => shift.status == 1)
          .map((shift, index) => (
            <div key={index} className="dashboard__weekschedule-pickthis">
              <div
                style={{
                  width: 300,
                }}
              >
                <span style={{ fontSize: "6", fontWeight: "bolder" }}>
                  {shift.name}
                </span>
                <h3>
                  {to12Hr(shift.start_time)} - {to12Hr(shift.end_time)}
                </h3>
              </div>
              <button
                type="button"
                className="btn btn-pick btn-brand"
                style={{
                  width: "100%",
                  backgroundColor: isSelected(shift.id) ? "#2AB57D" : "#5156BE",
                  borderRadius: 5,
                  justifyContent: "space-between",
                }}
                disabled={isDisabled()}
                onClick={() => {
                  !isDisabled() && togglePreferenceBtn(shift.id);
                }}
              >
                <span>
                  {isSelected(shift.id) ? t("Unpick") : t("Pick This")}
                </span>{" "}
                <i
                  className="fas fa-arrow-right"
                  style={{
                    marginTop: 5,
                  }}
                />
              </button>
            </div>
          ))}
      </div>
    </div>
  );
};

export default WeekDaySchedule;
